import PropTypes from 'prop-types';
import './FetchStatus.scss';
import { Spinner } from 'reactstrap';
import MaterialIcon from '@material/react-material-icon';

const FetchStatus = ({ type, info }) => {
  return (
    <div className="fetch-status">
      {type === 'loading' && <Spinner color="primary" size="sm" />}
      {type === 'error' && <MaterialIcon icon="error_outline" />}
      {type === 'empty' && <MaterialIcon icon="info_outline" className="text-warning" />}
      <span>
        {type === 'loading' && 'Sedang mengambil data..'}
        {type === 'error' && 'Gagal mengambil data'}
        {type === 'empty' && `Tidak ada data ${info !== undefined ? info : ''}`}
      </span>
    </div>
  );
};

FetchStatus.propTypes = {
  type: PropTypes.string,
  info: PropTypes.string,
};

export default FetchStatus;
